var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { TweenLite, TweenMax } from 'gsap/all';
import AssetLoader from 'mixins/AssetLoader';
import ErrorLogger from 'mixins/ErrorLogger';
import TypingActivityHelper from 'mixins/TypingActivityHelper';
import { ActivityManagerTyped as ActivityManager } from 'mixins/ActivityManager';
import DoneButton from '../components/activity/DoneButton.vue';
import HtmlRenderer from '../components/activity/HtmlRenderer.vue';
import ActivityNextSectionPortal from '../components/activity/ActivityNextSectionPortal.vue';
import ActivityStage from '../components/activity/ActivityStage.vue';
import ActivityWrapper from '../components/activity/ActivityWrapper.vue';
import mixins from 'vue-typed-mixins';
const HINT = 'HINT';
const INCORRECT_ATTEMPT = 'INCORRECT_ATTEMPT';
export default mixins(AssetLoader, ActivityManager(), //also used for graph-it-image
TypingActivityHelper, ErrorLogger).extend({
    name: 'HighlightIt',
    components: {
        DoneButton,
        HtmlRenderer,
        ActivityNextSectionPortal,
        ActivityWrapper,
        ActivityStage
    },
    data() {
        return {
            clickedElementIds: [],
            correctGuesses: [],
            loadedSvg: null,
            displayWrongIcon: false,
            displayCorrectIcon: false
        };
    },
    watch: {
        loadedSvg() {
            if (this.loadedSvg) {
                TweenLite.delayedCall(0.5, () => {
                    this.addElementClickHandler();
                    this.addSvgStyle();
                });
            }
        },
        currentRound: {
            immediate: true,
            handler() {
                this.fetchAsset();
            }
        }
    },
    methods: {
        getActivityState() {
            const { rounds, incorrectAttempt } = this.activityData;
            return {
                rounds,
                hint: rounds[0].hint,
                incorrectAttempt,
                instructions: Object.assign(Object.assign({}, rounds[0].instructions), { text: rounds[0].instructions.audio.description })
            };
        },
        loadActivity() {
            return __awaiter(this, void 0, void 0, function* () {
                const roundSetup = this.getActivityState();
                this.createRounds(roundSetup);
                const audiosMap = {
                    [HINT]: roundSetup.hint.audio.src,
                    [INCORRECT_ATTEMPT]: roundSetup.incorrectAttempt.audio.src
                };
                const audioDescriptionsMap = {
                    [HINT]: roundSetup.hint.audio.description,
                    [INCORRECT_ATTEMPT]: roundSetup.incorrectAttempt.audio.description
                };
                this.sfx = yield this.loadAAAudios(audiosMap);
                this.sfxDescriptions = audioDescriptionsMap;
            });
        },
        startActivity() {
            this.setRound();
            this.$nextTick(this.setActivityContainerHeight);
        },
        setRound() {
            this.setupNewRound();
            this.errorLoggerStart();
            this.$nextTick(() => {
                TweenMax.to('.activity-stage', 0.5, { opacity: 1 });
            });
        },
        fetchAsset() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.currentRound || !this.currentRound.mainContent)
                    return;
                return axios
                    .get(this.currentRound.mainContent.svg.src)
                    .then(({ data }) => {
                    this.loadedSvg = data;
                })
                    .catch(error => console.log(error, 'error'));
            });
        },
        showOrHideLayer(id, layerName, shouldHide, isHint = false) {
            const splitId = id.split('-');
            const elName = splitId[1];
            const selectedLayer = document.querySelector(`[id="${layerName}-${elName}" i]`);
            if (!selectedLayer)
                return;
            selectedLayer.style.opacity = shouldHide ? '0%' : '100%';
            if (layerName === 'selected') {
                const layerClipPath = selectedLayer.getElementsByTagName('clipPath')[0];
                const pathIndex = !!layerClipPath ? 1 : 0;
                const layerPath = selectedLayer.getElementsByTagName('path')[pathIndex];
                const layerCircle = selectedLayer.getElementsByTagName('circle')[0];
                const layerImage = selectedLayer.getElementsByTagName('image')[0];
                const colorLayer = layerPath || layerCircle;
                if (colorLayer) {
                    const color = !isHint ? '#87CBDE' : '#42a854';
                    colorLayer.style.fill = color;
                }
                if (layerImage && !shouldHide) {
                    selectedLayer.style.opacity = !isHint ? '1' : '0.5';
                }
            }
        },
        handleShowHint(delay = 1.5, playHint = true) {
            const correctElements = Array.from(document.querySelectorAll('[id$="correct" i]'));
            TweenLite.delayedCall(delay, () => {
                if (playHint)
                    this.playAudio(HINT);
                correctElements.forEach(el => {
                    if (this.correctGuesses.includes(el.id))
                        return;
                    if (!delay && this.clickedElementIds.includes(el.id))
                        return;
                    this.showOrHideLayer(el.id, 'selected', false, true);
                });
            });
        },
        removeClickedElement(id) {
            this.clickedElementIds = [...this.clickedElementIds].filter(arrId => arrId !== id);
        },
        addClickedElement(id) {
            this.clickedElementIds = [...this.clickedElementIds, id];
        },
        resetClickedElements(correctGuesses, wrongGuesses) {
            this.correctGuesses = correctGuesses;
            wrongGuesses.forEach(elId => {
                this.removeClickedElement(elId);
                this.showOrHideLayer(elId, 'wrong', true);
            });
        },
        handleHidingElement(id) {
            const hasAlreadyBeenGuessedCorrectly = this.numberOfAttempts[0] && id.includes('correct') && [...this.correctGuesses].includes(id);
            if (hasAlreadyBeenGuessedCorrectly)
                return;
            this.removeClickedElement(id);
            this.showOrHideLayer(id, 'selected', true);
            if (this.numberOfAttempts[0] >= 2)
                this.handleShowHint(0, false);
        },
        handleShowingElement(id) {
            if ([...this.clickedElementIds].length === this.currentRound.numAnswers)
                return;
            this.addClickedElement(id);
            this.showOrHideLayer(id, 'selected', false);
        },
        handleElementOnClick(el) {
            el.style.outline = 'none';
            const idToUse = el.id.length ? el.id : el.parentNode.id;
            if (this.clickedElementIds.includes(idToUse)) {
                this.handleHidingElement(idToUse);
                el.ariaPressed = 'false';
                return;
            }
            this.handleShowingElement(idToUse);
            el.ariaPressed = 'true';
        },
        addSvgStyle() {
            const svgHtmlSection = document.querySelector('.svgHtml');
            const svg = svgHtmlSection.getElementsByTagName('svg')[0];
            svg.style.height = '100%';
            svg.style.width = '100%';
        },
        addEventListeners(ClonedElement) {
            ClonedElement.addEventListener('click', () => this.handleElementOnClick(ClonedElement));
            ClonedElement.addEventListener('keypress', e => {
                if (e.key === 'Enter') {
                    this.handleElementOnClick(ClonedElement);
                }
            });
            ClonedElement.addEventListener('focusout', () => {
                ClonedElement.style.outline = 'none';
            });
        },
        addElementClickHandler() {
            const clickableEls = Array.from(document.querySelectorAll('[id^="click" i]'));
            if (!clickableEls)
                return;
            clickableEls.forEach((el, idx) => {
                const ClonedElement = el.cloneNode(true);
                if (ClonedElement) {
                    ClonedElement.style.cursor = 'pointer';
                    ClonedElement.tabIndex = 10;
                    ClonedElement.classList.add('focusable');
                    ClonedElement.role = 'button';
                    ClonedElement.ariaPressed = 'false';
                    this.addEventListeners(ClonedElement);
                }
                if (el && el.parentNode) {
                    el.parentNode.replaceChild(ClonedElement, el);
                }
            });
        },
        handleOnActivitySubmit() {
            if (this.displayCorrectIcon) {
                return;
            }
            this.incrementNumberOfAttempts();
            const clickedEls = [...this.clickedElementIds];
            let correctGuesses = [];
            let wrongGuesses = [];
            clickedEls.forEach(elId => {
                const answerIndicator = elId.split('-')[2];
                const isCorrect = answerIndicator === 'correct';
                const layerName = isCorrect ? 'correct' : 'wrong';
                isCorrect ? correctGuesses.push(elId) : wrongGuesses.push(elId);
                this.showOrHideLayer(elId, 'selected', true);
                this.showOrHideLayer(elId, layerName, false);
            });
            if (wrongGuesses.length || correctGuesses.length !== this.currentRound.numAnswers) {
                if (this.numberOfAttempts[0] <= 1)
                    this.playAudio(INCORRECT_ATTEMPT);
                if (this.numberOfAttempts[0] >= 2)
                    this.handleShowHint();
                this.displayWrongIcon = true;
                TweenLite.delayedCall(1.5, () => {
                    this.displayWrongIcon = false;
                    this.resetClickedElements(correctGuesses, wrongGuesses);
                });
                return;
            }
            this.displayCorrectIcon = true;
            TweenLite.delayedCall(1.5, () => {
                this.processEndOfActivity();
            });
        }
    }
});
